import { render, staticRenderFns } from "./loginHome.vue?vue&type=template&id=25d7fb8c&scoped=true&"
import script from "./loginHome.vue?vue&type=script&lang=js&"
export * from "./loginHome.vue?vue&type=script&lang=js&"
import style0 from "./loginHome.vue?vue&type=style&index=0&id=25d7fb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7fb8c",
  null
  
)

export default component.exports